import { BaseApiResponse } from '@/types/api/api-v2';
import { SkuDTO } from '@/types/api/sku';
import { spiritoryWebApi } from '../lib/axios/spiritoryWebApi';

export default async function getMostPopularAroundYou() {
  try {
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<SkuDTO[]>>('/sku/most-popular-around-you');
    return data;
  } catch (err) {
    console.error('[GET MOST POPULAR AROUND YOU]', err);
    throw new Error('Failed to fetch most popular around you');
  }
}
